import React, { useState, useEffect } from 'react'
import './index.css'
import { Button } from '@material-ui/core'
import { ReactComponent as Alert } from '../../assets/alert.svg'
import { ReactComponent as Close } from '../../assets/close_gray.svg'
import { isMobile } from 'react-device-detect'
import moment from 'moment'
import COLORS from '../../colors'
 
const ModalShiftClose = ({ popup, total, start, end, onClose, onConfirmation }) => {
		const [ width, setWidth ] = useState(window.innerWidth)
	    const [ height, setHeight ] = useState(window.innerHeight)
		const currDate = new Date()
        useEffect(()=>
		{
                function setInnerDimension()
				{
                        setWidth(window.innerWidth)
                        setHeight(window.innerHeight)	 	 
                }
                window.addEventListener('resize', setInnerDimension, false)
                return () => window.removeEventListener('resize', setInnerDimension, false)
        },[])

	if (!popup) return null
    return (
    			<div className="modal">
					<div className="overlay-modal" />
					<div className="modal-shift-close-body" style={{width:!isMobile?'25rem':'90%', height:!isMobile?(height>820?'21rem':'48%'):'50%'}}>
						<div className="modal-shift-close">
							<div className="modal-shift-close-title">Jesi li siguran?</div>
							<Close className="shift-close-btn" onClick={() => onClose()}/>
						</div>
						<Alert />
						{start!==end?
							<div className="modal-shift-close-text"> 
								Sigurno želiš zatvoriti smjenu sa iznosom {parseFloat(total).toFixed(2)} eura,
								{' '} 
								od dana {moment(start).format("DD.MM")} u {moment(start).format("HH:mm")},
								{' '}
								do {moment(end).format("DD.MM")}. u {moment(end).format("HH:mm")} sati?
								{' '}
								Info o zatvaranju smjene šalje se na e-mail adresu za izvještaje. 
						 	</div>:
							<div className="modal-shift-close-text"> 
								Sigurno želiš zatvoriti smjenu sa iznosom {parseFloat(total).toFixed(2)} eura,
								{' '} 
								od dana {moment(start).format("DD.MM")} u {moment(start).format("HH:mm")} sati?
								{' '} 
								Info o zatvaranju smjene šalje se na e-mail adresu za izvještaje. 
						 	</div>
						}
						<Button size="large" 
                 			variant="contained"
                 			style={{ width:'90%', 
                             	color:"#fff", 
                             	fontWeight: 'bold', 
                             	backgroundColor: COLORS.blue, 
                     		 	textTransform: 'none',
							 	margin:'1rem',
								"&:hover": {
									backgroundColor: COLORS.blue
							  	} 
                       			}} 
							onClick={() => onConfirmation()}
						>ZATVORI SMJENU</Button>
						<Button size="large" 
                 			variant="contained"
                 			style={{ width:'90%', 
                             		color:"#000",
									marginBottom: '1rem', 
                             		fontWeight: 'bold', 
                             		backgroundColor:'#fff',
									border: '2px solid #2F2F5B',  
                     		 		textTransform: 'none',
									"&:hover": {
										backgroundColor: '#fff'
							  		} 
                       				}} 
							onClick={() => onClose()}
						>ODUSTANI</Button>	
					</div>
    			</div>
	)
}

export default ModalShiftClose
